import SharedSvg from './shared-svg';
import { Status } from './status-chip';
import StatusLabel, { StatusType } from './status-label';

import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

interface SimpleFormHeaderProps {
  title: string;
  lastSavedDate?: number;
  isSaving?: boolean;
  status?: Status;
}

export default function SimpleFormHeader({
  title,
  lastSavedDate,
  isSaving,
  status,
}: SimpleFormHeaderProps) {
  const theme = useTheme();

  const statusValue = (status?.toUpperCase() as StatusType) ?? 'UNKNOWN';
  return (
    <>
      {/* Title */}
      <Grid
        sx={{
          p: 1.5,
          flexShrink: 0,
          borderBottom: '1px solid',
          borderBottomColor: (theme) => theme.palette.divider,
          mb: 1,
        }}
      >
        <Stack
          direction="row"
          spacing={1.8}
          alignItems="center"
          justifyContent="space-between"
        >
          <Stack direction="row" spacing={1.8} alignItems="center">
            <SharedSvg variant="formAccent" />
            <Typography
              variant="h6"
              sx={{
                fontWeight: 500,
              }}
            >
              {title}
            </Typography>
          </Stack>
          <Stack direction="row" spacing={1} alignItems="center">
            {isSaving ? (
              <>
                <CircularProgress
                  size={16}
                  sx={{ color: theme.palette.text.primary }}
                />
                <Typography
                  variant="caption"
                  sx={{
                    color: theme.palette.text.secondary,
                    fontStyle: 'italic',
                  }}
                >
                  Saving...
                </Typography>
              </>
            ) : lastSavedDate && lastSavedDate > 0 ? (
              <>
                <Typography
                  variant="caption"
                  sx={{
                    color: theme.palette.text.secondary,
                    fontStyle: 'italic',
                  }}
                >
                  Last saved:{' '}
                  {new Date(lastSavedDate).toLocaleString('en-US', {
                    month: 'numeric',
                    day: 'numeric',
                    year: 'numeric',
                    hour: 'numeric',
                    minute: '2-digit',
                    hour12: true,
                  })}
                </Typography>
              </>
            ) : null}
            {statusValue !== 'UNKNOWN' ? (
              <StatusLabel status={statusValue} />
            ) : null}
          </Stack>
        </Stack>
      </Grid>
    </>
  );
}
